export default "__VITE_ASSET__BMU00Nv4__"